
    (function() {
        'use strict';

        var ROOT_SEL = '.product-detail-content';
        var KEY = '__pd_bound';

        /* ---------- 基础工具 ---------- */
        function toArray(nl) {
            var out = [];
            if (!nl) return out;
            for (var i = 0; i < nl.length; i++) {
                out.push(nl[i]);
            }
            return out;
        }

        /* Element.closest 兼容（低版本浏览器） */
        if (!Element.prototype.closest) {
            Element.prototype.closest = function(selector) {
                var el = this;
                while (el && el.nodeType === 1) {
                    var m = el.matches && el.matches(selector);
                    if (m) return el;
                    el = el.parentElement;
                }
                return null;
            };
        }

        /* 让非原生按钮元素可聚焦、支持键盘 */
        function makeFocusable(el) {
            if (!el || el.nodeType !== 1) return;
            if (!el.hasAttribute('tabindex')) {
                el.setAttribute('tabindex', '0');
            }
            var tag = el.tagName.toLowerCase();
            if (tag !== 'button' && tag !== 'a' && tag !== 'input') {
                el.setAttribute('role', 'button');
            }
            el.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    el.click();
                }
            });
        }

        /* ---- 全局预解码队列：空闲时逐帧 decode，拖动命中的帧即时渲染、不闪 ---- */
        var _decQ = [];
        var _decBusy = false;
        function enqDecode(im) {
            if (im && _decQ.indexOf(im) === -1) _decQ.push(im);
        }
        function decLoop() {
            var n = 0;
            while (_decQ.length && n < 2) {
                var im = _decQ.shift();
                n++;
                if (im && im.decode) {
                    try {
                        var p = im.decode();
                        if (p && p.catch) p.catch(function() {});
                    } catch (err) {}
                }
            }
            if (_decQ.length) {
                setTimeout(decLoop, 40);
            } else {
                _decBusy = false;
            }
        }
        function kickDecode() {
            if (!_decBusy && _decQ.length) {
                _decBusy = true;
                setTimeout(decLoop, 60);
            }
        }

        /* 图片懒加载（支持 data-src 占位） */
        function ensureSlideImg(slide) {
            if (!slide) return;
            var img = slide.querySelector('img');
            if (!img) return;
            if (img.dataset && img.dataset.src && img.getAttribute('src') !== img.dataset.src) {
                img.src = img.dataset.src;
            }
        }

        /* ============================================================
           Read More（按内容真实高度平滑展开/收起）
           ============================================================ */
        function bindReadMore(btn) {
            if (btn[KEY]) return;
            btn[KEY] = true;
            makeFocusable(btn);

            var wrapperId = btn.getAttribute('aria-controls');
            var wrapper = wrapperId ? document.getElementById(wrapperId) : null;
            if (!wrapper) return;

            var openTimer = null;

            function finishOpen() {
                // 过渡完成后放开固定高度，避免窄屏重排/内容超高被裁
                wrapper.style.maxHeight = 'none';
            }

            btn.addEventListener('click', function() {
                var expanded = btn.getAttribute('aria-expanded') === 'true';

                if (expanded) {
                    /* ---- 收起 ---- */
                    var h = wrapper.scrollHeight;
                    wrapper.style.maxHeight = h + 'px';
                    wrapper.classList.remove('expanded');
                    void wrapper.offsetHeight; /* 强制 reflow */
                    wrapper.style.maxHeight = '0px';
                    btn.setAttribute('aria-expanded', 'false');
                    clearTimeout(openTimer);
                    openTimer = setTimeout(function() {
                        wrapper.style.removeProperty('max-height');
                    }, 700);
                } else {
                    /* ---- 展开 ---- */
                    var targetH = wrapper.scrollHeight;
                    wrapper.classList.add('expanded');
                    wrapper.style.maxHeight = targetH + 'px';
                    btn.setAttribute('aria-expanded', 'true');
                    clearTimeout(openTimer);
                    openTimer = setTimeout(finishOpen, 650);

                    // 平滑滚动到展开内容顶部
                    setTimeout(function() {
                        var top = wrapper.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - 20;
                        if (top < 0) top = 0;
                        window.scrollTo({ top: top, behavior: 'smooth' });
                    }, 60);
                }
            });
        }

        /* ============================================================
           Watch / 滑块 / 视频弹窗
           ============================================================ */
        var lockDepth = 0;
        var lockPrev = '';

        function lockBody(on) {
            if (on) {
                if (lockDepth === 0) {
                    lockPrev = document.body.style.overflow;
                    document.body.style.overflow = 'hidden';
                }
                lockDepth++;
            } else if (lockDepth > 0) {
                lockDepth--;
                if (lockDepth === 0) {
                    document.body.style.overflow = lockPrev;
                }
            }
        }

        /* 每个区块（.an-box-wrapper）独立初始化：滑块 + Watch More + 视频 */
        function bindSlider(wrapper) {
            if (wrapper[KEY]) return;
            wrapper[KEY] = true;

            var box = wrapper.querySelector('.custom-slider-box');
            var viewBtn = wrapper.querySelector('.watch-more-btn');
            var closeBtn = box ? box.querySelector('.close') : null;

            /* 无 watch 按钮的区块：仅兜底绑定关闭按钮 */
            if (!box || !viewBtn) {
                if (closeBtn) {
                    makeFocusable(closeBtn);
                    closeBtn.addEventListener('click', function(e) {
                        e.preventDefault();
                        box.classList.remove('active');
                        var v = wrapper.querySelector('.watch-more-btn');
                        if (v) v.setAttribute('aria-expanded', 'false');
                    });
                }
                return;
            }
            makeFocusable(viewBtn);

            var slideWrap = box.querySelector('.slides');
            var slides = slideWrap ? toArray(slideWrap.querySelectorAll('.slide')) : [];
            var range = box.querySelector('.range');
            var cur = 0;
            var btnRow = viewBtn.closest('.btnbox-an') || wrapper;
            var total = slides.length;
            var declaredTotal = parseInt(viewBtn.getAttribute('data-total'), 10);
            var imgPrefix = (viewBtn.getAttribute('data-img-list') || '').trim();

            /* 定位本区块自己的视频弹窗（不再全局取第一个） */
            var section = wrapper.closest('.pdp-feature-section') || wrapper;
            var popup = section.querySelector('.video-popup-container') ||
                        document.querySelector('.video-popup-container');
            var player = popup ? popup.querySelector('.video-popup-player') : null;

            /* 视频弹窗关闭逻辑只绑定一次 */
            if (popup && player && !popup[KEY]) {
                popup[KEY] = true;
                var closeBtnV = popup.querySelector('.video-popup-close');
                var overlay = popup.querySelector('.video-popup-overlay');

                var closePopup = function() {
                    if (popup.style.display === 'none') return;
                    popup.style.display = 'none';
                    try { player.pause(); } catch (err) {}
                    player.removeAttribute('src');
                    try { player.load(); } catch (err) {}
                    lockBody(false);
                };
                popup.__pdClose = closePopup;

                if (closeBtnV) {
                    makeFocusable(closeBtnV);
                    closeBtnV.addEventListener('click', closePopup);
                }
                if (overlay) overlay.addEventListener('click', closePopup);
            }

            /* ---- 帧序列：按 data-total 用 data-img-list 前缀补齐完整动画帧 ---- */
            var tailPrefix = '';
            var imgExt = '.jpg';
            if (slides.length) {
                var imFirst = slides[0].querySelector('img');
                var mTail = imFirst
                    ? (imFirst.getAttribute('src') || '').match(/^(.*?)(\d+)(\.(?:jpe?g|png|webp))$/i)
                    : null;
                if (mTail) {
                    tailPrefix = mTail[1];
                    imgExt = mTail[3].toLowerCase();
                }
            }
            var srcPrefix = imgPrefix || tailPrefix;
            if (srcPrefix && declaredTotal > slides.length && slideWrap) {
                while (slideWrap.firstChild) slideWrap.removeChild(slideWrap.firstChild);
                slides = [];
                for (var fi = 0; fi < declaredTotal; fi++) {
                    var fr = document.createElement('div');
                    fr.className = 'slide';
                    var fimg = document.createElement('img');
                    fimg.src = srcPrefix + fi + imgExt;
                    fimg.alt = '';
                    fimg.setAttribute('decoding', 'async'); /* 解码不阻塞主线程 */
                    /* 全部立即加载：手动拖动要求任意帧随拖随到，不能等按需加载 */
                    fr.appendChild(fimg);
                    enqDecode(fimg); /* 进入后台预解码队列 */
                    slideWrap.appendChild(fr);
                    slides.push(fr);
                }
                total = slides.length;
            }

            /* 手动拖动模式：帧序列在生成时已全部加载，
               拖动 range 或画面即可任意定位帧，不做自动播放 */

            function syncFill() {
                if (!range) return;
                var max = (range.max - range.min) || 1;
                var pct = ((parseFloat(range.value) - range.min) / max) * 100;
                range.style.setProperty('--fill', pct + '%');
            }

            function showAt(i, fromRange) {
                if (!total) return;
                cur = i;
                if (cur < 0) cur = 0;
                if (cur > total - 1) cur = total - 1;
                for (var k = 0; k < slides.length; k++) {
                    if (k === cur) {
                        slides[k].classList.add('active');
                        ensureSlideImg(slides[k]);
                    } else {
                        slides[k].classList.remove('active');
                    }
                }
                if (range) {
                    if (!fromRange) range.value = cur;
                    syncFill();
                }
                decodeAround(cur);
            }

            /* 当前帧及其前后各 3 帧强制预解码：拖动扫过时全部即时显示、无空白闪 */
            function decodeAround(i) {
                var lo = Math.max(0, i - 3);
                var hi = Math.min(total - 1, i + 3);
                for (var d = lo; d <= hi; d++) {
                    var im = slides[d] ? slides[d].querySelector('img') : null;
                    if (im && im.decode) {
                        var p = im.decode();
                        if (p && p.catch) p.catch(function() {});
                    }
                }
            }

            /* 把动画画面固定到 Watch More 按钮正下方：按钮永远在动画上方。
               初始 DOM 里 box 可能紧挨在按钮前面，也可能被 read-more/内容节点隔开，
               统一用 previousElementSibling 判断并归位，保证各产品页表现一致 */
            function moveUnderButton() {
                var pp = btnRow.parentNode;
                if (pp && box.parentNode === pp && box.previousElementSibling !== btnRow) {
                    pp.insertBefore(box, btnRow.nextSibling);
                }
            }
            /* 初始化即归位：box 默认 display:none，不影响首屏布局，也避免首次点击时跳位 */
            moveUnderButton();

            function openBox() {
                moveUnderButton();
                cur = 0;
                box.classList.add('active');
                viewBtn.setAttribute('aria-expanded', 'true');
                showAt(0);
                setTimeout(function() {
                    box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }, 80);
            }

            function closeBox() {
                box.classList.remove('active');
                viewBtn.setAttribute('aria-expanded', 'false');
            }

            if (closeBtn) {
                makeFocusable(closeBtn);
                closeBtn.addEventListener('click', function(e) {
                    e.preventDefault();
                    closeBox();
                });
            }

            viewBtn.addEventListener('click', function() {
                var imgList = (this.getAttribute('data-img-list') || '').trim();
                var videoUrl = (this.getAttribute('data-video-url') || '').trim();

                /* 视频优先 */
                if (videoUrl && popup && player) {
                    player.innerHTML = '';
                    var s = document.createElement('source');
                    s.src = videoUrl;
                    s.type = 'video/mp4';
                    player.appendChild(s);
                    try { player.load(); } catch (err) {}
                    popup.style.display = 'block';
                    lockBody(true);
                    var p = player.play();
                    if (p && p.catch) {
                        p.catch(function() { /* 自动播放被拦截时保留控制条 */ });
                    }
                    return;
                }

                /* 图片滑块 */
                if (imgList) {
                    if (box.classList.contains('active')) {
                        closeBox();
                    } else {
                        openBox();
                    }
                }
            });

            /* ---- range 拖动 = 时间轴 scrub ---- */
            if (range) {
                range.max = Math.max(0, total - 1);
                range.addEventListener('input', function() {
                    showAt(parseInt(this.value, 10), true);
                });
                syncFill();
            }

            /* ---- 画面上水平拖动 = 时间轴 scrub（连续映射，不是一格一格跳） ---- */
            var dragX = null;
            var dragBase = 0;
            var dragRate = 0;

            if (slideWrap && total > 1) {
                slideWrap.addEventListener('pointerdown', function(e) {
                    if (e.pointerType === 'mouse' && e.button !== 0) return;
                    dragRate = Math.max(160, slideWrap.clientWidth) / (total - 1);
                    dragX = e.clientX;
                    dragBase = cur;
                });
                slideWrap.addEventListener('pointermove', function(e) {
                    if (dragX === null) return;
                    var d = Math.round((dragX - e.clientX) / dragRate);
                    var t = dragBase + d;
                    if (t < 0) t = 0;
                    if (t > total - 1) t = total - 1;
                    if (t !== cur) {
                        cur = t;
                        showAt(cur);
                    }
                });
                ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function(evt) {
                    slideWrap.addEventListener(evt, function() { dragX = null; });
                });
            }

            kickDecode(); /* 启动本滑块帧序列的后台预解码 */
        }

        /* ============================================================
           初始化：按 DOM 结构自动发现所有产品区块（任何产品通用）
           ============================================================ */
        function bindRoot(root) {
            toArray(root.querySelectorAll('.an-box-wrapper')).forEach(bindSlider);
            toArray(root.querySelectorAll('.read-more-btn')).forEach(bindReadMore);

            /* pc/mobile 双份展示图：隐藏的一份交给浏览器懒加载 */
            toArray(root.querySelectorAll('.pc-slider img, .mobile-slider img')).forEach(function(im) {
                if (!im.hasAttribute('loading')) im.setAttribute('loading', 'lazy');
            });
        }

        function initAll() {
            toArray(document.querySelectorAll(ROOT_SEL)).forEach(bindRoot);
        }

        function init() {
            initAll();

            /* Esc 关闭任意已打开的视频弹窗 */
            document.addEventListener('keydown', function(e) {
                if (e.key !== 'Escape') return;
                toArray(document.querySelectorAll('.video-popup-container')).forEach(function(c) {
                    if (c.style.display !== 'none' && c.__pdClose) {
                        c.__pdClose();
                    }
                });
            });

            /* 页面构建器/异步注入内容时的兜底 */
            if (window.MutationObserver) {
                var mo = new MutationObserver(function(mutations) {
                    for (var m = 0; m < mutations.length; m++) {
                        var added = mutations[m].addedNodes;
                        for (var n = 0; n < added.length; n++) {
                            var node = added[n];
                            if (node && node.nodeType === 1) {
                                var hit = (node.querySelector && node.querySelector(ROOT_SEL + ', .an-box-wrapper, .read-more-btn')) ||
                                          (node.matches && node.matches(ROOT_SEL + ', .an-box-wrapper, .read-more-btn'));
                                if (hit) {
                                    initAll();
                                    return;
                                }
                            }
                        }
                    }
                });
                mo.observe(document.documentElement, { childList: true, subtree: true });
            }
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            init();
        }

    })();
    